var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6006 9L34 16.0845C34 17.75 32.7207 19 31.2051 19C29.6846 19 28.4053 17.6655 28.4053 16.083C28.4053 17.75 27.124 19 25.6045 19C24.083 19 22.8037 17.6655 22.8037 16.083C22.8037 17.75 21.5225 19 20.0029 19C18.4824 19 17.2021 17.6655 17.2021 16.083C17.2021 17.75 15.9209 19 14.4014 19C12.8809 19 11.6016 17.6655 11.6016 16.083C11.6016 17.75 10.3203 19 8.80078 19C7.2793 19 6 17.6655 6 16.083L10.3994 9H29.6006ZM11.5 23C11.5 22.1714 10.8281 21.5 10 21.5C9.17188 21.5 8.5 22.1714 8.5 23V29C8.5 29.8286 9.17188 30.5 10 30.5H30C30.8281 30.5 31.5 29.8286 31.5 29V23C31.5 22.1714 30.8281 21.5 30 21.5C29.1719 21.5 28.5 22.1714 28.5 23V27.5H11.5V23Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCredit);
export default __webpack_public_path__ + "static/media/icon-credit.3a0679f5a12decdaa53a4c6e313c6c5c.svg";
export { ForwardRef as ReactComponent };